import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "./App.css";
import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Carousel from "react-bootstrap/Carousel";
import logo from "./img/petshop.png";

import Header from "./components/layout/Header";
import Home from "./components/pages/Home";
import Container from "./components/layout/Container";
import Footer from "./components/layout/Footer";

function App() {
  return (
    <Router>
      <main className="app_container">
        <Header />
        <Carousel className="home_carousel">
          <Carousel.Item>
            <div className="home_carouselItens">
              <h1>
                Bem-vindo ao <span>Petshop Catarina</span>
              </h1>
              <img src={logo} alt="logotipo petshop catarina"></img>
              <p>
                Encontre tudo que seu animal de estimação precisa em nossa loja!
              </p>
            </div>
          </Carousel.Item>
        </Carousel>

        <Switch>
          <Container>
            <Route exact path="/">
              <Home />
            </Route>
          </Container>
        </Switch>
        <Footer />
      </main>
    </Router>
  );
}

export default App;
